import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["history"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * App router component.
 *
 * @author Mikhail Siutsou
 * @component
 * @category components
 * @param {BrowserHistory} history history.
 * @return {React.ReactElement | null} app router component.
 */
var AppRouter = function AppRouter(_ref) {
  var history = _ref.history,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState({
    action: history.action,
    location: history.location
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useLayoutEffect(function () {
    return history.listen(setState);
  }, [history]);
  return /*#__PURE__*/_jsx(Router, _objectSpread(_objectSpread({}, props), {}, {
    location: state.location,
    navigationType: state.action,
    navigator: history
  }));
};

export { AppRouter };